import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MainRouterComponent } from './common/main-router/main-router.component';
import { FaqComponent } from './faq/faq.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { CreditsComponent } from './credits/credits.component';
import { ContactsComponent } from './contacts/contacts.component';
import { UserAccountComponent } from './user-account/user-account.component';
import { BlogComponent } from './common/blog/blog.component';
import { DynamicPageComponent } from './common/dynamic-page/dynamic-page.component';
import { BookingDetailComponent } from './user-account/booking-detail/booking-detail.component';
import { BookingListComponent } from './user-account/booking-list/booking-list.component';
import { ResetPasswordComponent } from './shared/reset-password/reset-password.component';
import { SmsLoginComponent } from './shared/sms-login/sms-login.component';
import { GeneralBookingComponent } from './shared/general-booking-detail/general-booking-detail';
import { DynamicSearchComponent } from './booking/dynamic-search/dynamic-search.component';
import { BlogSingleComponent } from './common/blog/single/blog-single.component';
import { VacaturesComponent } from './vacatures/vacatures.component';

const routes: Routes = [
    {path: '', redirectTo: 'vliegtickets', pathMatch: 'full'},
    {path: '', component: MainRouterComponent,
        children: [
            // {path: '',  redirectTo: 'booking', pathMatch: 'full'},
            {path: 'veelgestelde-vragen', component: FaqComponent},
            {path: 'login', component: SmsLoginComponent},
            {path: 'ticket/:id', component: BlogSingleComponent},
            {path: 'blog', component: BlogComponent},
            {path: 'over-ons', component: AboutusComponent},
            {path:'page/:id',component:DynamicPageComponent},
            {path: 'ticks-spaarsysteem', component: CreditsComponent},
            {path: 'contact', component: ContactsComponent},
            {path: 'vacatures', component: VacaturesComponent},
            {path: 'userAccount', component: UserAccountComponent},
            {path: 'booking', component: BookingListComponent},
            {path: 'booking/detail/:id', component: BookingDetailComponent},
            {path:'userbooking/:id',component:GeneralBookingComponent},
            {path: 'vliegticket/:id', component: DynamicSearchComponent},
            {path:'resetpassword/:id',component:ResetPasswordComponent},
            {path: 'vliegtickets', loadChildren: () => import('app/booking/booking.module').then(m => m.BookingModule),
            data: { preload: true }}
        ]
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
